let globalToastFn = null

export function registerToast(fn) {
  globalToastFn = fn
}

export function showToast(message, options = {}) {
  if (typeof globalToastFn === 'function') {
    globalToastFn(message, options)
  }
}
